import { createFileRoute } from "@tanstack/react-router";
import { APP_NAME } from "@/config/constants";

export const Route = createFileRoute("/_home/terms-of-service")({
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} - Terms of Service`,
      },
    ],
  }),
  component: TermsOfService,
});

function TermsOfService() {
  return (
    <div className="container mx-auto max-w-4xl px-4 py-8 pt-20">
      <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>

      <div className="prose prose-gray dark:prose-invert max-w-none">
        <p className="text-sm text-gray-600 mb-6">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
          <p>
            By accessing and using FilePrompt ("the Service"), you accept and agree to be bound by
            the terms and provision of this agreement. If you do not agree to abide by the above,
            please do not use this service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. Description of Service</h2>
          <p>
            FilePrompt is an AI-powered chat application that helps users manage files and interact
            with artificial intelligence. The Service allows users to upload, organize, and chat
            about their files using AI technology.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. User Accounts</h2>
          <p>
            To use certain features of the Service, you may be required to create an account. You
            are responsible for maintaining the confidentiality of your account information and for
            all activities that occur under your account.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. Data Storage and Privacy</h2>
          <p>
            User data is stored on our servers to provide the Service. We are committed to
            protecting your privacy and handling your data responsibly. For detailed information
            about how we collect, use, and protect your data, please refer to our Privacy Policy.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. Data Deletion Rights</h2>
          <p>
            You have the right to delete all your data at any time. Upon request for data deletion,
            all your personal data and files will be permanently deleted from our servers. This
            action cannot be undone.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">6. Acceptable Use</h2>
          <p>
            You agree not to use the Service for any unlawful purpose or in any way that could
            damage, disable, overburden, or impair our servers or networks. You shall not attempt to
            gain unauthorized access to any part of the Service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">7. Intellectual Property</h2>
          <p>
            The Service and its original content, features, and functionality are owned by
            FilePrompt and are protected by international copyright, trademark, patent, trade
            secret, and other intellectual property laws.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">8. Limitation of Liability</h2>
          <p>
            In no event shall FilePrompt be liable for any indirect, incidental, special,
            consequential, or punitive damages, including without limitation, loss of profits, data,
            use, goodwill, or other intangible losses.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">9. Service Availability</h2>
          <p>
            We strive to maintain the Service availability but do not guarantee uninterrupted
            access. We may temporarily suspend the Service for maintenance, updates, or other
            operational reasons.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">10. Modifications to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. We will notify users of any
            material changes. Your continued use of the Service after such modifications constitutes
            acceptance of the updated terms.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">11. Termination</h2>
          <p>
            We may terminate or suspend your account and access to the Service immediately, without
            prior notice, for conduct that we believe violates these Terms of Service or is harmful
            to other users, us, or third parties.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">12. Contact Information</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us through the
            appropriate channels provided in the application.
          </p>
        </section>
      </div>
    </div>
  );
}
